import { render } from "./CollectionPostTextSettingsEditor.vue?vue&type=template&id=93a73754&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./CollectionPostTextSettingsEditor.vue?vue&type=script&lang=js"
export * from "./CollectionPostTextSettingsEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a73754"]])

export default __exports__